module.exports = new __parcel__URL__("objective_read_button.7124ee6d.png").toString();